module.exports = __webpack_public_path__ + "static/media/charts_g.87d100e8.png";